import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, ArrowRight } from "lucide-react";
import { BUSINESS, NAV_LINKS } from "@/lib/constants";

export const Logo = ({ dark = false }) => (
  <Link to="/" data-testid="logo-link" className="flex items-center gap-3">
    <span className="flex h-10 w-10 items-center justify-center rounded-lg border border-[#C9A227]/50 bg-[#08080A] shadow-sm">
      <span className="font-heading text-sm font-semibold tracking-tight text-[#E4C463]">
        J11
      </span>
    </span>
    <span className="leading-tight">
      <span className={`block font-heading text-lg font-bold tracking-tight ${dark ? "text-white" : "text-[#F2EEE3]"}`}>
        {BUSINESS.shortName}
      </span>
      <span className={`block text-[9px] font-semibold tracking-[0.24em] ${dark ? "text-[#8D877B]" : "text-[#9E978A]"}`}>
        {BUSINESS.tagline}
      </span>
    </span>
  </Link>
);

export const Navbar = ({ sticky = true }) => {
  const [open, setOpen] = useState(false);

  return (
    <header data-testid="main-navbar" className={`${sticky ? "sticky" : "relative"} top-0 z-50 border-b border-white/10 bg-[#0B0B0E]/90 backdrop-blur-xl`}>
      <div className="mx-auto flex h-[72px] max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <Logo />
        <nav className="hidden items-center gap-8 lg:flex" data-testid="desktop-nav">
          {NAV_LINKS.map((link) => (
            <Link
              key={link.label}
              to={link.to}
              data-testid={`nav-link-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="group relative text-sm font-medium text-[#B8B2A6] transition-colors duration-200 hover:text-[#F2EEE3]"
            >
              {link.label}
              <span className="absolute -bottom-1 left-0 h-0.5 w-0 bg-[#C9A227] transition-[width] duration-300 group-hover:w-full" />
            </Link>
          ))}
        </nav>
        <div className="hidden lg:block">
          <Link
            to="/#consultation"
            data-testid="nav-free-consultation-btn"
            className="group inline-flex items-center gap-2 rounded-lg bg-gradient-to-b from-[#E7C766] to-[#AE8924] px-5 py-2.5 text-sm font-semibold text-black shadow-sm transition-colors duration-200 hover:from-[#F2D47E] hover:to-[#C49B2E]"
          >
            Free Consultation
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5" />
          </Link>
        </div>
        <button
          type="button"
          data-testid="mobile-menu-toggle"
          aria-label="Toggle navigation menu"
          onClick={() => setOpen(!open)}
          className="flex h-10 w-10 items-center justify-center rounded-lg border border-white/10 text-[#F2EEE3] lg:hidden"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>
      {open && (
        <div data-testid="mobile-menu" className="border-t border-white/10 bg-[#101014] px-4 pb-6 pt-4 lg:hidden">
          <nav className="flex flex-col gap-1">
            {NAV_LINKS.map((link) => (
              <Link
                key={link.label}
                to={link.to}
                data-testid={`mobile-nav-link-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-3 text-base font-medium text-[#D9D4C8] transition-colors duration-200 hover:bg-[#141419] hover:text-[#F2EEE3]"
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/#consultation"
              data-testid="mobile-free-consultation-btn"
              onClick={() => setOpen(false)}
              className="mt-3 inline-flex items-center justify-center gap-2 rounded-lg bg-gradient-to-b from-[#E7C766] to-[#AE8924] px-5 py-3 text-sm font-semibold text-black transition-colors duration-200 hover:from-[#F2D47E] hover:to-[#C49B2E]"
            >
              Free Consultation
              <ArrowRight className="h-4 w-4" />
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
};
